export default {
	SYSTEM_USER: 'SYSTEM_USER',
	EXTERNAL_USER: 'EXTERNAL_USER',
}